var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDummyNuvoLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 240 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "mainGradient",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#2563eb",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#1e40af",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "accentGradient",
    x1: "100%",
    y1: "0%",
    x2: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#60a5fa",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#3b82f6",
      stopOpacity: 1
    }
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "scale(0.85) translate(75, 30)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 100,
    r: 90,
    stroke: "url(#mainGradient)",
    strokeWidth: 4,
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(45 100 100)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 25,
    r: 8,
    fill: "url(#accentGradient)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 175,
    r: 8,
    fill: "url(#accentGradient)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 100,
    r: 8,
    fill: "url(#accentGradient)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 175,
    cy: 100,
    r: 8,
    fill: "url(#accentGradient)"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 100,
    r: 70,
    stroke: "url(#mainGradient)",
    strokeWidth: 2,
    strokeDasharray: "8 4",
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 100,
    r: 50,
    stroke: "url(#accentGradient)",
    strokeWidth: 3,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "textCircle",
    d: "M100,60 A40,40 0 1,1 99.99,60",
    fill: "none"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "url(#mainGradient)",
    fontSize: 24,
    fontWeight: "bold",
    letterSpacing: 4
  }, /*#__PURE__*/React.createElement("textPath", {
    href: "#textCircle",
    startOffset: "5%"
  }, "N U V O")), /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 100,
    r: 6,
    fill: "url(#mainGradient)"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "url(#accentGradient)",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M100,40 L100,45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100,155 L100,160"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40,100 L45,100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155,100 L160,100"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDummyNuvoLogo);
export default __webpack_public_path__ + "static/media/dummy-nuvo-logo.c7e7fea66e1b83e92289fa1a67b3fb30.svg";
export { ForwardRef as ReactComponent };